import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type GlobalMessageSettingQueryVariables = {};


export type GlobalMessageSettingQuery = (
  { __typename?: 'Query' }
  & { globalSettingByType: Types.Maybe<(
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id' | 'type'>
    & { globalMessage: Types.Maybe<(
      { __typename?: 'GlobalMessage' }
      & Pick<Types.GlobalMessage, 'message' | 'isActive'>
    )> }
  )> }
);

export const GlobalMessageSettingDocument = gql`
    query GlobalMessageSetting {
  globalSettingByType(type: globalMessage) {
    _id
    type
    ... on GlobalMessageSetting {
      globalMessage {
        message
        isActive
      }
    }
  }
}
    `;

    export function useGlobalMessageSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalMessageSettingQuery, GlobalMessageSettingQueryVariables>) {
      return ApolloReactHooks.useQuery<GlobalMessageSettingQuery, GlobalMessageSettingQueryVariables>(GlobalMessageSettingDocument, baseOptions);
    };
      export function useGlobalMessageSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalMessageSettingQuery, GlobalMessageSettingQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<GlobalMessageSettingQuery, GlobalMessageSettingQueryVariables>(GlobalMessageSettingDocument, baseOptions);
      };
      
export type GlobalMessageSettingQueryHookResult = ReturnType<typeof useGlobalMessageSettingQuery>;
export type GlobalMessageSettingQueryResult = ApolloReactCommon.QueryResult<GlobalMessageSettingQuery, GlobalMessageSettingQueryVariables>;